export default () => (
  <div>
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33311 6.16667V23.5C5.33311 24.0746 5.56138 24.6257 5.96771 25.0321C6.37404 25.4384 6.92514 25.6667 7.49977 25.6667H20.4998C21.0744 25.6667 21.6255 25.4384 22.0318 25.0321C22.4382 24.6257 22.6664 24.0746 22.6664 23.5V10.8705C22.6664 10.5819 22.6087 10.2961 22.4967 10.0301C22.3847 9.76407 22.2207 9.5231 22.0143 9.32134L17.2043 4.6175C16.7995 4.22171 16.2559 4.00007 15.6898 4H7.49977C6.92514 4 6.37404 4.22827 5.96771 4.6346C5.56138 5.04093 5.33311 5.59203 5.33311 6.16667Z"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="9.1249"
        y="8.33331"
        width="8.125"
        height="1.625"
        fill="currentColor"
      />
      <path
        d="M8.0002 13.9522C8.0002 13.4263 8.42651 13 8.95239 13H19.4265C19.9524 13 20.3787 13.4263 20.3787 13.9522V22.0061C20.3787 22.532 19.9524 22.9583 19.4265 22.9583H8.95239C8.42651 22.9583 8.0002 22.532 8.0002 22.0061V13.9522Z"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <path
        d="M14.4749 13L14.4754 22.9583"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="20.3787"
        y1="15.8217"
        x2="8.00021"
        y2="15.8217"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="20.3787"
        y1="18.3213"
        x2="8.00021"
        y2="18.3213"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="20.3787"
        y1="20.8208"
        x2="8.00021"
        y2="20.8208"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <path
        d="M17.5697 13L17.57 22.9583"
        stroke="currentColor"
        stroke-width="1.2"
      />
    </svg>
  </div>
);
